window.addEventListener('DOMContentLoaded', () => {
    const tiktokClass = '.b-tiktok__swiper';
    const tiktokContainer = document.querySelector(tiktokClass);
    if (tiktokContainer) {
        const tiktokCount = tiktokContainer && tiktokContainer.querySelectorAll('.b-tiktok__swiper-inner .swiper-slide').length;
        const videos = tiktokContainer.querySelectorAll('.tiktok-embed iframe');
        if (window.innerWidth >= 768) {
            tiktokCount <= 4 ? tiktokContainer.classList.add('no-swiper') : tiktokContainer.classList.remove('no-swiper');
        }

        var tiktokSwiper = new Swiper(tiktokContainer, {
            slidesPerView: "auto",
            centeredSlides: true,
            spaceBetween: 0,
            autoHeight: false,
            resizeObserver: false,
            watchOverflow: true,
            loop: true,
            focusableElements: 'iframe',
            pagination: {
                el: '.swiper-pagination-tiktok',
                clickable: true,
            },
            navigation: {
                nextEl: '.swiper-button-next-tiktok',
                prevEl: '.swiper-button-prev-tiktok',
            },
            // breakpoints: {
            //     1301: {
            //         centeredSlides: true,
            //         loop: true,
            //     }
            // }
        })

        tiktokSwiper.on('slideChange', function () {
            videos.forEach(video => {
                const player = video.contentWindow;
                player.postMessage('{"method":"pause"}', '*');
            });
        });
    }
});
